'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const Formatters=require('../../../dist-es6/client/formatters');let

DurationDirective=function(_BaseDirective){_inherits(DurationDirective,_BaseDirective);function DurationDirective(){_classCallCheck(this,DurationDirective);return _possibleConstructorReturn(this,_BaseDirective.apply(this,arguments))}DurationDirective.prototype.








link=function link($scope,$element){
let updateTime=function(){
fastdom.mutate(function(){
if(!_.exists($scope.hours)){
angular.element($element[0]).text('--');
return;
}

angular.element($element[0]).text(`${Formatters.timeSpanAsHoursAndMinutes(timespan.fromHours($scope.hours))}`);
});
};

$scope.$watch('hours',updateTime);

updateTime();
};_createClass(DurationDirective,[{key:'restrict',get:function(){return'A'}},{key:'objectBindings',get:function(){return['hours']}}]);return DurationDirective}(BaseDirective);


module.exports=DurationDirective;
//# sourceMappingURL=durationDirective.js.map
